import pdf from "./../../Files/regulations.pdf"


export default pdf
